// A cutscene's score (the town's cutscenes, D1.4, phase D joined): when story asks for a scene (`story:scene`), its
// sting plays through the game's one audio engine, on its one AudioContext (index.ts listens; the handle's
// `cutscene()` plays it as a scene would). A cutscene never makes a context of its own.
//
// Planted defect `audio-second-context` (gate D2.4): the cutscene makes its own AudioContext for its score, as a
// cutscene player written on its own might; the one-context check (contexts constructed on the page) must go red.
import type { Audio } from "@rpg/audio";
import type { SpikeBoot } from "../boot";

/** What playing the stand-in cutscene's score did. */
export interface CutsceneResult {
  /** Through the engine (one context), or a context of its own (the planted defect). */
  via: "engine" | "own-context";
  played: boolean;
}

/** Play the cutscene's score. */
export function playCutscene(d: { engine: Audio; boot: SpikeBoot; secondContext: boolean }): CutsceneResult {
  if (d.secondContext) {
    // the defect: a context of its own, a sting on it, and an offer to the engine (refused and reported)
    const own = new AudioContext();
    const osc = own.createOscillator();
    const g = own.createGain();
    g.gain.value = 0.05;
    osc.connect(g).connect(own.destination);
    osc.start();
    osc.stop(own.currentTime + 0.4);
    d.engine.attach(own);
    return { via: "own-context", played: true };
  }
  return { via: "engine", played: d.engine.play("cutscene.sting").played };
}
